export const EVENT_LABELS: Record<string, string> = {
  checkout_opened: 'Checkout aberto',
  ticket_quantity_changed: 'Quantidade alterada',
  step_1_completed: 'Etapa 1 concluída',
  participant_field_filled: 'Campo do participante preenchido',
  step_2_completed: 'Etapa 2 concluída',
  optional_selected: 'Opcional selecionado',
  step_3_completed: 'Etapa 3 concluída',
  payment_method_selected: 'Método de pagamento selecionado',
  payment_started: 'Pagamento iniciado',
  payment_approved: 'Pagamento aprovado',
  payment_failed: 'Pagamento falhou',
  checkout_abandoned: 'Carrinho abandonado',
  identify: 'Identificação'
};

export const STEP_LABELS: Record<string, string> = {
  landing: 'Entrada',
  form: 'Formulário',
  payment: 'Pagamento'
};

export const STATUS_LABELS: Record<string, string> = {
  active: 'Ativo',
  abandoned: 'Abandonado',
  converted: 'Convertido'
};

export function getEventNameLabel(value?: string | null): string {
  if (!value) return '–';
  return EVENT_LABELS[value] ?? value;
}

export function getStepLabel(value?: string | null): string {
  if (!value) return '–';
  return STEP_LABELS[value] ?? value;
}

export function getStatusLabel(value?: string | null): string {
  if (!value) return '–';
  return STATUS_LABELS[value] ?? value;
}
